export default "__VITE_ASSET___zHTrN$P__"